export default __webpack_public_path__ + "static/media/tiktok.59f1d621.png";